// Eingaben in Euro und Prozent. Die Umrechnung ist eine Einheitenumrechnung, keine Regel.
import { parseMoneyCents } from '../shared/money'

/**
 * '4.275,00' → 427500, '' → null, Unsinn → null. `parseMoneyCents` ist die strenge Grammatik aus
 * src/shared/money.ts — dieselbe, mit der der Worker FinSuites-Beträge liest. Sie *wirft* bei
 * ungültiger Eingabe einen `ParseError`; hier wird er zu `null`, weil ein Formularfeld einen
 * Tippfehler als ungültig markiert und nicht den Klick-Handler abbricht. Eine im onChange geworfene
 * Ausnahme fängt keine React-Fehlergrenze — der Bildschirm bliebe stehen, weil jemand einen Punkt
 * statt eines Kommas getippt hat.
 */
export function centsAusEingabe(text: string): number | null {
  if (text.trim() === '') return null
  try {
    return parseMoneyCents(text, 'de-DE')
  } catch {
    return null
  }
}

/**
 * 427500 → '4275,00'. Für das Vorbelegen eines Eingabefelds; ohne Tausenderpunkt, damit es wieder lesbar ist.
 * Achtung bei negativen Beträgen: das Minuszeichen, das diese Funktion schreibt, kennt die Grammatik von
 * `parseMoneyCents` nicht — `centsAusEingabe(eingabeAusCents(-500))` ist `null`. Wer ein Feld mit einem
 * negativen Betrag vorbelegt, führt das Vorzeichen getrennt vom Betrag.
 */
export function eingabeAusCents(cents: number): string {
  const vorzeichen = cents < 0 ? '-' : ''
  const betrag = Math.abs(cents)
  return `${vorzeichen}${Math.trunc(betrag / 100)},${String(betrag % 100).padStart(2, '0')}`
}

/**
 * Prozent → Basispunkte. Bewusst NICHT `parsePercentBp` aus src/shared/money.ts: das ist die v25-Heuristik für
 * FinSuites-Felder („ein Wert > 1 meint Prozent“), unter der die Eingabe „1“ 100 % bedeutet. In einem Formular,
 * in dem jemand den Host-Anteil tippt, wäre das ein zwanzigfacher Fehlbetrag.
 */
export function bpAusProzent(prozent: number): number {
  return Math.round(prozent * 100)
}

/** 750 → 7.5, für das Vorbelegen eines Prozentfelds. */
export function prozentAusBp(bp: number): number {
  return bp / 100
}
